import "./careers";
import "./savings";
import "./pricing";
import "./scripts";

import Vue from 'vue';
import PasswordInput from "./login/PasswordInput";

window.Vue = Vue;
Vue.component("password-input", PasswordInput)